var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProcedures(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "20.000000pt",
    height: "20.000000pt",
    viewBox: "0 0 128.000000 128.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,128.000000) scale(0.100000,-0.100000)",
    fill: "#ffffff",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M344 1047 c-3 -8 -4 -52 -2 -98 l3 -84 295 0 295 0 0 95 0 95 -293 3 c-238 2 -293 0 -298 -11z m556 -87 l0 -60 -260 0 -260 0 0 60 0 60 260 0 260 0 0 -60z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225 1010 c-3 -5 -4 -14 0 -20 3 -5 -28 -10 -77 -12 -66 -2 -83 -6 -83 -18 0 -12 18 -16 80 -20 60 -4 80 -9 80 -19 0 -26 20 -22 50 9 l29 30 -29 30 c-31 32 -40 36 -50 20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M985 970 c-12 -19 6 -30 48 -30 51 0 100 -28 127 -72 25 -41 25 -82 2 -127 -24 -48 -61 -72 -123 -79 -38 -5 -54 -11 -54 -22 0 -26 82 -25 135 2 132 67 132 249 0 316 -46 23 -124 30 -135 12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344 727 c-3 -8 -4 -52 -2 -98 l3 -84 115 0 c96 0 115 3 115 15 0 12 -19 16 -97 18 l-98 3 0 59 0 60 260 0 260 0 0 -60 0 -59 -97 -3 c-79 -2 -98 -6 -98 -18 0 -12 19 -15 115 -15 l115 0 0 95 0 95 -293 3 c-238 2 -293 0 -298 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160 638 c-132 -67 -132 -249 0 -316 53 -27 135 -28 135 -2 0 11 -15 16 -51 20 -84 9 -144 66 -144 140 0 74 60 131 144 140 36 4 51 9 51 20 0 26 -82 25 -135 -2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624 569 c-10 -17 13 -36 27 -22 12 12 4 33 -11 33 -5 0 -12 -5 -16 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344 407 c-3 -8 -4 -52 -2 -98 l3 -84 295 0 295 0 0 95 0 95 -293 3 c-238 2 -293 0 -298 -11z m556 -87 l0 -60 -260 0 -260 0 0 60 0 60 260 0 260 0 0 -60z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1145 370 c-3 -5 -4 -14 0 -20 3 -5 -28 -10 -77 -12 -66 -2 -83 -6 -83 -18 0 -12 18 -16 80 -20 60 -4 80 -9 80 -19 0 -26 20 -22 50 9 l29 30 -29 30 c-31 32 -40 36 -50 20z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcedures);
export default __webpack_public_path__ + "static/media/procedures.df8f0ba3438a2b84c7362983d90bc75f.svg";
export { ForwardRef as ReactComponent };